import React from "react";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import Loader from "./shared/Loader";

// Layouts
import Layout2 from "./shared/layouts/Layout2";
// import LayoutBlank from "./shared/layouts/LayoutBlank";

// Lazy load component
const lazy = (cb) =>
  loadable(() => pMinDelay(cb(), 200), { fallback: <Loader /> });

// ---
// Default application layout

export const DefaultLayout = Layout2;

// ---
// Document title template

export const titleTemplate = "%s - Galitra";

// ---
// Routes
//
// Note: By default all routes use { "exact": true }. To change this
// behaviour, pass "exact" option explicitly to the route object

export const defaultRoute = "/";
export const routes = [
  {
    path: "/",
    component: lazy(() => import("./components/Home"))
  },
  // Parametrage

  // catalogue
  {
    path: "/parametrage/catalogue/article",
    component: lazy(() => import("./components/pages/Parametrage/Article"))
  },
  {
    path: "/parametrage/catalogue/famille",
    component: lazy(() =>
      import("./components/pages/Parametrage/Famille/Famille")
    )
  },
  {
    path: "/parametrage/catalogue/numerisation",
    component: lazy(() => import("./components/pages/Parametrage/Numerisation"))
  },
  // crm
  {
    path: "/parametrage/crm/client",
    component: lazy(() =>
      import("./components/pages/Parametrage/Client/Client")
    )
  },
  {
    path: "/parametrage/crm/client/:id",
    component: lazy(() =>
      import("./components/pages/Parametrage/Client/ClientDetails")
    )
  },

  {
    path: "/parametrage/crm/fournisseur",
    component: lazy(() => import("./components/pages/Parametrage/Fournisseur"))
  },
  // transport
  {
    path: "/parametrage/transport/vehicule",
    component: lazy(() => import("./components/pages/Parametrage/Vehicule"))
  },
  {
    path: "/parametrage/transport/chauffeur",
    component: lazy(() => import("./components/pages/Parametrage/Chauffeur"))
  },
  {
    path: "/parametrage/stock/reservoir",
    component: lazy(() => import("./components/pages/Parametrage/Reservoir"))
  },
  {
    path: "/parametrage/stock/reservoir/:id",
    component: lazy(() => import("./components/pages/Parametrage/Pompe"))
  },
  // Achat
  {
    path: "/achat/commandes",
    component: lazy(() =>
      import("./components/pages/Achat/BonCommande/BonCommande")
    )
  },
  {
    path: "/achat/commande/:id",
    component: lazy(() => import("./components/pages/Achat/BonCommande/EditBc"))
  },
  {
    path: "/achat/receptions",
    component: lazy(() =>
      import("./components/pages/Achat/BonReception/BonReception")
    )
  },
  {
    path: "/achat/reception/:id",
    component: lazy(() =>
      import("./components/pages/Achat/BonReception/EditRc")
    )
  },
  {
    path: "/achat/avoirs",
    component: lazy(() =>
      import("./components/pages/Achat/FactureAvoir/FactureAvoir")
    )
  },
  {
    path: "/achat/avoir/:id",
    component: lazy(() =>
      import("./components/pages/Achat/FactureAvoir/EditFA")
    )
  },
  {
    path: "/achat/factures",
    component: lazy(() => import("./components/pages/Achat/Facture/Facture"))
  },
  {
    path: "/achat/facture/:id",
    component: lazy(() => import("./components/pages/Achat/Facture/EditFc"))
  },
  // Achat

  // Achat
  {
    path: "/vente/devis",
    component: lazy(() => import("./components/pages/Vente/Devis/Devis"))
  },
  {
    path: "/achat/devi/:id",
    component: lazy(() => import("./components/pages/Vente/Devis/EditDevis"))
  },

  {
    path: "/vente/bgs",
    component: lazy(() => import("./components/pages/Vente/BonG/BonG"))
  },
  {
    path: "/achat/bg/:id",
    component: lazy(() => import("./components/pages/Vente/BonG/EditBonG"))
  },
  {
    path: "/vente/bls",
    component: lazy(() => import("./components/pages/Vente/BonL/BonL"))
  },
  {
    path: "/achat/bl/:id",
    component: lazy(() => import("./components/pages/Vente/BonL/EditBonL"))
  },

  // Gestion des prix

  {
    path: "/prix/divers",
    component: lazy(() => import("./components/pages/Prix/Divers/Divers"))
  }

  //   {
  //     path: "/Facturation",
  //     component: lazy(() =>
  //       import("./components/pages/Achat/Facturation/Facturations")
  //     )
  //   },
  //   {
  //     path: "/AddNewFacturation",
  //     component: lazy(() =>
  //       import("./components/pages/Achat/Facturation/AjouteFacturation")
  //     )
  //   },
  //   {
  //     path: "/FactureAvoir",
  //     component: lazy(() =>
  //       import("./components/pages/Achat/FactureAvoir/FactureAvoir")
  //     )
  //   },
  //   {
  //     path: "/AddNewFactureAvoir",
  //     component: lazy(() =>
  //       import("./components/pages/Achat/FactureAvoir/AjouteFactureAvoir")
  //     )
  //   }
  //   {
  //     path: "/accountSettings",
  //     component: lazy(() => import("./components/pages/AccountSettings"))
  //   },
  //   {
  //     path: "/users",
  //     component: lazy(() => import("./components/pages/UsersList"))
  //   },
  //   {
  //     path: "/user",
  //     component: lazy(() => import("./components/pages/UsersView"))
  //   },
  //   {
  //     path: "/user_edit",
  //     component: lazy(() => import("./components/pages/UsersEdit"))
  //   },
  //   {
  //     path: "/login",
  //     component: lazy(() => import("./components/pages/AuthenticationLogin")),
  //     layout: LayoutBlank
  //   },
  //   {
  //     path: "/register",
  //     component: lazy(() => import("./components/pages/AuthenticationRegister")),
  //     layout: LayoutBlank
  //   },
  //   {
  //     path: "/lockscreen",
  //     component: lazy(() =>
  //       import("./components/pages/AuthenticationLockScreen")
  //     ),
  //     layout: LayoutBlank
  //   }
];
